import React from "react";
import logo from "../assets/logo.png";
import "./Hero.css";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>Badminton Coaching in Melbourne</h1>
        <p>Train Hard. Smash Harder.</p>
        {/* ✅ Redirects to Availability Form */}
        <Link to="/availability" className="hero-btn">Enroll Now</Link>
      </div>
    </section>
  );
}
